import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { TranslationService } from '@core/services/common/translation.service';
import { take } from 'rxjs/operators';

/** Calls the public translation of the translation service and finds interpolation tokens (e.g. {0}) in the translated string */
@Pipe({
  name: 'translation',
  pure: false,
})
export class TranslationPipe implements PipeTransform {
  private lastValue = '';

  constructor(
    private translationService: TranslationService,
    private cdr: ChangeDetectorRef,
  ) {}

  transform(value: string, args?: any[]): string {
    // Do nothing if input is undefined
    if (!value) {
      return;
    }

    this.translationService.detectChange.pipe(take(1)).subscribe((_) => {
      // Translate
      const translation = this.translationService.pt(value, args);

      this.lastValue = translation;
      this.cdr.markForCheck();
    });

    // Return the translated (and maybe interpolated) string.
    return this.lastValue;
  }
}
